import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwStickyModule } from '@aw/ads-components/src/directives/aw-sticky';
import { AwComponent } from '@aw/ads-components/aw-parent';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@aw/ads-components/src/directives/aw-sticky';

const _c0 = ["*"];
class AwAnchoredBottomPanelComponent extends AwComponent {
    constructor() {
        super(...arguments);
        this.stickyClass = 'aw-sticky';
        this.stickyBoundaryContainer = '.main-content';
        this.stickyPosition = 'bottom';
    }
}
AwAnchoredBottomPanelComponent.ɵfac = function AwAnchoredBottomPanelComponent_Factory(t) { return ɵAwAnchoredBottomPanelComponent_BaseFactory(t || AwAnchoredBottomPanelComponent); };
AwAnchoredBottomPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwAnchoredBottomPanelComponent, selectors: [["aw-anchored-bottom-panel"]], inputs: { stickyClass: "stickyClass", stickyBoundaryContainer: "stickyBoundaryContainer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 2, vars: 3, consts: [["aw-sticky", "", 1, "aw-anchored-bottom-panel", 3, "aw-sticky-class", "aw-sticky-position", "aw-sticky-boundary-container"]], template: function AwAnchoredBottomPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("aw-sticky-class", ctx.stickyClass)("aw-sticky-position", ctx.stickyPosition)("aw-sticky-boundary-container", ctx.stickyBoundaryContainer);
    } }, directives: [ɵngcc1.AwStickyDirective], encapsulation: 2 });
AwAnchoredBottomPanelComponent.propDecorators = {
    stickyClass: [{ type: Input }],
    stickyBoundaryContainer: [{ type: Input }]
};
const ɵAwAnchoredBottomPanelComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwAnchoredBottomPanelComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwAnchoredBottomPanelComponent, [{
        type: Component,
        args: [{
                selector: 'aw-anchored-bottom-panel',
                template: "<div\n    class=\"aw-anchored-bottom-panel\"\n    aw-sticky\n    [aw-sticky-class]=\"stickyClass\"\n    [aw-sticky-position]=\"stickyPosition\"\n    [aw-sticky-boundary-container]=\"stickyBoundaryContainer\"\n>\n    <ng-content></ng-content>\n</div>"
            }]
    }], null, { stickyClass: [{
            type: Input
        }], stickyBoundaryContainer: [{
            type: Input
        }] }); })();

class AwAnchoredBottomPanelModule {
}
AwAnchoredBottomPanelModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwAnchoredBottomPanelModule });
AwAnchoredBottomPanelModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwAnchoredBottomPanelModule_Factory(t) { return new (t || AwAnchoredBottomPanelModule)(); }, imports: [[
            CommonModule,
            AwStickyModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwAnchoredBottomPanelModule, { declarations: function () { return [AwAnchoredBottomPanelComponent]; }, imports: function () { return [CommonModule,
        AwStickyModule]; }, exports: function () { return [AwAnchoredBottomPanelComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwAnchoredBottomPanelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AwStickyModule
                ],
                declarations: [
                    AwAnchoredBottomPanelComponent
                ],
                exports: [
                    AwAnchoredBottomPanelComponent
                ]
            }]
    }], null, null); })();

export { AwAnchoredBottomPanelComponent, AwAnchoredBottomPanelModule };

//# sourceMappingURL=aw-ads-components-aw-anchored-bottom-panel.js.map